<template>
    <div class="flex w-full flex-col gap-4 rounded bg-white p-6 shadow">
        <div class="font-semibold">Password</div>
        <div class="">
            <form-input
                type="password"
                label="Current Password"
                v-model="form.current_password"
                name="current_password"
            />
        </div>
        <div class="">
            <form-input
                type="password"
                label="New Password"
                v-model="form.new_password"
                name="new_password"
            />
        </div>
        <div class="">
            <form-input
                type="password"
                label="Confirm New Password"
                v-model="form.new_password_confirmation"
                name="new_password_confirmation"
            />
        </div>
        <div class="flex justify-end">
            <div
                v-if="form.isDirty"
                @click="submit"
                class="rounded bg-primary-525 px-2 py-3 text-white hover:cursor-pointer hover:bg-primary-625"
            >
                Update password
            </div>
            <div
                v-else
                class="rounded bg-primary-525 px-2 py-3 text-white opacity-50 hover:cursor-not-allowed"
            >
                Update password
            </div>
        </div>
    </div>
</template>
<script>
import FormInput from "@/Components/FormInput.vue";

export default {
    name: "StudentChangePasswordForm",
    components: { FormInput },
    props: {},
    data() {
        return {
            form: this.$inertia.form({
                current_password: "",
                new_password: "",
                new_password_confirmation: "",
            }),
        };
    },
    methods: {
        submit() {
            let vm = this;

            this.$inertia.post(
                route("user.update-password"),
                {
                    current_password: this.form.current_password,
                    new_password: this.form.new_password,
                    new_password_confirmation:
                        this.form.new_password_confirmation,
                },
                {
                    preserveScroll: true,
                    onSuccess: function () {
                        vm.form.reset();
                    },
                }
            );
        },
    },
};
</script>
